document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-lc-header]');
  var menuButton = document.querySelector('[data-lc-menu]');
  var mobilePanel = document.querySelector('[data-lc-panel]');
  var heroMedia = document.querySelector('[data-lc-hero-media]');
  var reveals = document.querySelectorAll('[data-lc-reveal]');
  var tiltItems = document.querySelectorAll('[data-lc-tilt]');
  var puttRail = document.querySelector('[data-putt-rail]');
  var magneticButtons = document.querySelectorAll('[data-lc-magnetic]');

  function handleScroll() {
    var y = window.scrollY || window.pageYOffset;
    var maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    var progress = Math.max(0, Math.min(y / maxScroll, 1));
    document.documentElement.style.setProperty('--lc-putt-progress', progress.toFixed(3));
    if (header) header.classList.toggle('is-scrolled', y > 40);
    if (puttRail) puttRail.classList.toggle('is-sunk', progress > 0.97);
    if (heroMedia) heroMedia.style.transform = 'translateY(' + Math.min(y * 0.12, 72) + 'px) scale(1.03)';
  }
  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });

  if (menuButton && mobilePanel) {
    menuButton.addEventListener('click', function () {
      mobilePanel.classList.toggle('is-open');
    });
    mobilePanel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobilePanel.classList.remove('is-open');
      });
    });
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    reveals.forEach(function (item) { observer.observe(item); });
  } else {
    reveals.forEach(function (item) { item.classList.add('is-visible'); });
  }

  tiltItems.forEach(function (item) {
    item.addEventListener('mousemove', function (e) {
      if (window.innerWidth < 981) return;
      var rect = item.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      var rx = (0.5 - y) * 5;
      var ry = (x - 0.5) * 5;
      item.style.transform = 'perspective(1000px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(-2px)';
    });
    item.addEventListener('mouseleave', function () {
      item.style.transform = '';
    });
  });

  magneticButtons.forEach(function (button) {
    button.addEventListener('mousemove', function (e) {
      if (window.innerWidth < 981) return;
      var rect = button.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      button.style.transform = 'translate(' + (x * 0.08) + 'px,' + (y * 0.08) + 'px)';
    });
    button.addEventListener('mouseleave', function () {
      button.style.transform = '';
    });
  });

  document.querySelectorAll('[data-lc-filter]').forEach(function (button) {
    button.addEventListener('click', function () {
      var filter = button.getAttribute('data-lc-filter');
      var group = button.closest('[data-lc-filter-group]');
      if (!group) return;
      group.querySelectorAll('[data-lc-filter]').forEach(function (b) { b.classList.remove('is-active'); });
      button.classList.add('is-active');
      document.querySelectorAll('[data-lc-product-card]').forEach(function (card) {
        var cat = card.getAttribute('data-lc-category');
        card.style.display = (filter === 'all' || cat === filter) ? '' : 'none';
      });
    });
  });
});
